import Swiper from 'https://unpkg.com/swiper@7/swiper-bundle.esm.browser.min.js';

// import Swiper, { Navigation, Pagination } from 'swiper';
const hero_el = document.querySelector(".hero_swiper"); // const autoplay = hero_el.dataset.autoplay;

const delay = parseInt(hero_el.dataset.delay);
new Swiper(hero_el, {
  loop: true,
  effect: 'fade',
  // autoHeight: true,
  autoplay: {
    delay: delay
  },
  // effect: 'fade',
  slidesPerView: 1,
  // spaceBetween: 0,
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});
